import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseExpressReport() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getExpressList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Logestic_ExpressReport?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getExpressById = (expressID, callback) => {
    MyAxios.get(`Admin_Logestic_ExpressReport/${expressID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetAccountCredit = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_ExpressReport/accountcredit`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };
  const updateAlopeykOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_ExpressReport/updateorder`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const updateAllAlopeykOrder = (callback) => {
    MyAxios.post(`Admin_Logestic_ExpressReport/updateorders`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data);
        }
      }
    );
  };

  return {
    getExpressList,
    getExpressById,
    updateAlopeykOrder,
    updateAllAlopeykOrder,
    GetAccountCredit,
  };
}
